import { useEffect, useState } from "react";
import { TrendingUp, Users, Hash } from "lucide-react";
import client from "@/lib/glossyApi";

export const GrowthPanel = () => {
  const [g, setG] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    client.get("/admin/social/growth").then((r) => setG(r.data)).catch(() => setErr(true));
  }, []);

  if (err || !g) return null;

  const withReach = g.recent.filter((r) => r.reach != null);
  const avgReach = withReach.length ? Math.round(withReach.reduce((a, r) => a + r.reach, 0) / withReach.length) : null;
  const totalEng = g.recent.reduce((a, r) => a + r.likes + r.comments, 0);

  return (
    <div className="mx-6 sm:mx-10 mt-6 border border-ink/15 p-6 sm:p-7" data-testid="growth-panel">
      <div className="flex items-center justify-between mb-5">
        <p className="overline text-ink/60 flex items-center gap-2"><TrendingUp size={14} /> Growth — @{g.username}</p>
        <a href={`https://instagram.com/${g.username}`} target="_blank" rel="noreferrer" className="overline text-ink/40 hover:text-ink transition-colors" data-testid="growth-profile-link">Open profile ↗</a>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5">
        <div data-testid="growth-followers">
          <p className="font-serif text-3xl">{g.followers_count ?? "—"}</p>
          <p className="overline text-ink/45 flex items-center gap-1"><Users size={11} /> Followers</p>
        </div>
        <div data-testid="growth-posts">
          <p className="font-serif text-3xl">{g.media_count ?? "—"}</p>
          <p className="overline text-ink/45">Posts live</p>
        </div>
        <div data-testid="growth-reach">
          <p className="font-serif text-3xl">{avgReach ?? "—"}</p>
          <p className="overline text-ink/45">Avg reach / post</p>
        </div>
        <div data-testid="growth-engagement">
          <p className="font-serif text-3xl">{totalEng}</p>
          <p className="overline text-ink/45">Likes + comments</p>
        </div>
      </div>
      {g.top_hashtags.length > 0 && (
        <div className="mb-4" data-testid="growth-hashtags">
          <p className="overline text-ink/45 mb-2 flex items-center gap-1"><Hash size={11} /> Best-performing tags</p>
          <div className="flex flex-wrap gap-2">
            {g.top_hashtags.slice(0, 6).map((t) => (
              <span key={t.tag} className="font-mono text-xs bg-secondary px-2.5 py-1">{t.tag} · {t.avg}</span>
            ))}
          </div>
        </div>
      )}
      {g.recent.length > 0 ? (
        <div className="space-y-1.5" data-testid="growth-recent">
          {g.recent.slice(0, 4).map((r) => (
            <a key={r.id} href={r.permalink} target="_blank" rel="noreferrer" className="flex items-center justify-between gap-3 font-sans text-xs text-ink/70 hover:text-ink transition-colors">
              <span className="truncate">{r.caption || "(no caption)"}</span>
              <span className="shrink-0 font-mono text-ink/50">{r.reach != null ? `${r.reach} reach · ` : ""}{r.likes}♥ {r.comments}💬</span>
            </a>
          ))}
        </div>
      ) : (
        <p className="font-sans text-xs text-ink/45">Numbers appear here as posts go live — check back after your first few days of posting.</p>
      )}
    </div>
  );
};
